import { jsonIf } from '../utils/utils.network';

export const getPresignedURL = (fileName: string) => {
  const url = `${process.env.EDGE_URL}/v1/images/uploadurl?fileName=${fileName}&api_key=${process.env.API_KEY}`;
  return fetch(url, {
    headers: {
      referer: `${process.env.EDGE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => jsonIf(res))
    .then((json) => json.data)
    .catch((error) => {
      throw `Error when getting presigned URL for fileName ${fileName}. Response status ${error}`;
    });
};

export const uploadImage = (presignedUrl: string, file: File) => {
  return fetch(presignedUrl, {
    method: 'PUT',
    mode: 'cors',
    body: file,
  });
};

export const validateImage = (tempFileName: string, imageGroupGuid: string, category: string) => {
  const url = `${process.env.EDGE_URL}/v1/images/validateimagewiththumbnail?fileName=${tempFileName}&imageGroupGuid=${imageGroupGuid}&category=${category}&api_key=${process.env.API_KEY}`;
  return fetch(url, {
    headers: {
      referer: `${process.env.EDGE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => jsonIf(res))
    .then((json) => json.data.isValid)
    .catch((error) => {
      throw `Error when validating image. TempFileName: ${tempFileName}, imageGroupGuid: ${imageGroupGuid}, category: ${category}. Response status: ${error}`;
    });
};

export const deleteImage = (imageGroupGuid: string, category: string) => {
  const url = `${process.env.EDGE_URL}/v1/imagewiththumbnail/id/${imageGroupGuid}/category/${category}?api_key=${process.env.API_KEY}`;
  return fetch(url, {
    headers: {
      referer: `${process.env.EDGE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'DELETE',
    mode: 'cors',
  })
    .then((res) => jsonIf(res))
    .catch((error) => {
      throw `Error when deleting image for imageGroupGuid ${imageGroupGuid}, category ${category}. Response status ${error}`;
    });
};

export const fetchImages = (imageGroupGuid: string) => {
  const url = `${process.env.EDGE_URL}/v1/images/id/${imageGroupGuid}?api_key=${process.env.API_KEY}`;
  return fetch(url, {
    headers: {
      referer: `${process.env.EDGE_URL}`,
      authorization: `Basic ${process.env.ICO_TOKEN}`,
    },
    method: 'GET',
    mode: 'cors',
  })
    .then((res) => jsonIf(res).then((json) => json.data?.items || []))
    .catch((error) => {
      throw `Error when fetching images for imageGroupGuid ${imageGroupGuid}. Response status ${error}`;
    });
};
